import type { Drug } from '@/api/domains/drugs.types';
import { nomenclatureEmitter } from '@/components/nomenclature/events/nomenclature-emitter';

// ----------------------------------------------------------------------

const EVENT_NAME = 'create';

// ----------------------------------------------------------------------

export const unsubscribe = (callbackFn: (data: Drug) => void) => nomenclatureEmitter.off(EVENT_NAME, callbackFn);

export const subscribe = (callbackFn: (data: Drug) => void) => {
  nomenclatureEmitter.on(EVENT_NAME, callbackFn);

  return () => unsubscribe(callbackFn);
};

// ----------------------------------------------------------------------

export const emit = (data: Drug) => nomenclatureEmitter.emit(EVENT_NAME, data);
